import React from "react";
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";

const useStyles = makeStyles({
  card: {
    margin: "auto",
    width: "80%",
  },
  title: {
    fontSize: 25,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function NotaBimestreTipoProfile({ notaBimestreTipo }) {
  const classes = useStyles();

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent>
        <Grid container justifyContent="space-evenly" spacing={3}>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4,
            }}
          >
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
            >
              Código
            </Typography>
            <Typography variant="h5" component="h2">
              {notaBimestreTipo && notaBimestreTipo.codigo
                ? notaBimestreTipo.codigo
                : ""}
            </Typography>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4,
            }}
          >
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
            >
              Nome
            </Typography>
            <Typography variant="h5" component="h2">
              {notaBimestreTipo && notaBimestreTipo.descricao
                ? notaBimestreTipo.descricao
                : ""}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
